export default __webpack_public_path__ + "static/media/pattern_106.600d4a11.png";